import { POSE_COUNT } from '../poses/library'
import { useAppStore } from '../store'

export function AboutModal() {
  const open = useAppStore((s) => s.showAbout)
  const setShowAbout = useAppStore((s) => s.setShowAbout)
  if (!open) return null

  return (
    <div className="modal-backdrop" role="presentation" onClick={() => setShowAbout(false)}>
      <div className="modal" role="dialog" aria-modal="true" aria-labelledby="about-title" onClick={(e) => e.stopPropagation()}>
        <h2 id="about-title">About &amp; limitations</h2>
        <p>
          <strong>Yoga Anatomy Studio</strong> is an educational tool for instructors ({POSE_COUNT} poses).
          It is <em>not</em> medical advice, diagnosis, or EMG measurement.
        </p>
        <h3>Body model vs anatomy atlas</h3>
        <ul>
          <li>
            Primary animatable body: <strong>Vitruvian / CharMorph CC0</strong> Mixamo-rigged female
            humanoid (skinned GLB) with light clothing. See ATTRIBUTION.md.
          </li>
          <li>
            <a href="https://github.com/wiiiimm/human-atlas" target="_blank" rel="noreferrer">human-atlas</a>{' '}
            (BodyParts3D + HRA female, CC BY 4.0) is a <strong>static</strong> atlas without skeleton/skin
            weights and has incomplete external genital skin envelope. This app does <strong>not</strong> fake
            BodyParts3D animation.
          </li>
          <li>
            Genitals/breasts: the rigged model is lightly clothed; pelvic overlay is schematic only.
            Incomplete external anatomy is disclosed rather than invented.
          </li>
        </ul>
        <h3>Science caveats</h3>
        <ul>
          <li>Muscle colors = expected teaching involvement, not %MVC or EMG.</li>
          <li>No detox / toxin-flush claims. Metabolic waste is handled by the liver and kidneys.</li>
          <li>Decorative organ/circulation layers are schematic, not imaging.</li>
        </ul>
        <h3>Browser limits</h3>
        <ul>
          <li>Video uses canvas.captureStream + MediaRecorder (WebM common; MP4 if supported).</li>
          <li>Some mobile/Safari builds lack codecs — use Still PNG or Chrome/Firefox desktop.</li>
        </ul>
        <button type="button" className="primary" onClick={() => setShowAbout(false)}>Close</button>
      </div>
    </div>
  )
}
